import React from 'react';
import { useFormikContext } from 'formik';
import { Input } from 'syngenta-digital-cropwise-react-ui-kit';

import { FormValues } from 'screens/Applications&WorkOrders/StepsLayout/Constants/formikData';
import LayoutConstants from 'screens/Applications&WorkOrders/StepsLayout/Constants/layoutConstants';
import FormGrid, { FormRowConfig } from 'components/FormGrid';
import { COL_SPAN_FULL } from 'components/FormGrid/constants';
import './index.css';

const { TextArea } = Input;

const MAX_CHARACTERS = LayoutConstants.NOTES_MAX_CHARACTERS;

interface NotesSectionProps {
  excludeFields?: string[];
}

const NotesSection: React.FC<NotesSectionProps> = ({ excludeFields = [] }) => {
  const { values, handleChange, handleBlur } = useFormikContext<FormValues>();

  const currentLength = (values.notes || '').length;
  const isOverLimit = currentLength > MAX_CHARACTERS;
  const countColor = isOverLimit ? '#CF3537' : '#696F88';

  const formRows: FormRowConfig[] = [
    {
      id: 'notes-row',
      fields: [
        {
          id: 'notes',
          colSpan: COL_SPAN_FULL,
          error: undefined,
          render: () => (
            <div>
              <TextArea
                name="notes"
                value={values.notes || ''}
                onChange={handleChange}
                onBlur={handleBlur}
                rows={4}
                status={isOverLimit ? 'error' : undefined}
                className="notes-textarea"
                aria-label="Application notes"
                style={{
                  width: '100%',
                  height: '100%',
                  resize: 'none',
                  minHeight: '200px'
                }}
                autoSize={false}
              />
              <div
                className="text-right text-xs"
                style={{
                  fontSize: '12px',
                  fontWeight: 400,
                  fontStyle: 'normal',
                  color: countColor,
                  marginTop: '4px'
                }}
              >
                {currentLength.toLocaleString()} /{' '}
                {MAX_CHARACTERS.toLocaleString()} characters
              </div>
            </div>
          )
        }
      ]
    }
  ];

  return <FormGrid rows={formRows} excludeFields={excludeFields} />;
};

export default NotesSection;
